import { cx } from 'emotion';
import { CSSProperties, ReactNode } from 'react';

import { DeviceInfo } from '@ezugi/utils';

import { textContainer } from './style.css';

type TextProps = {
  label: string;
  value: string | number;
  children?: ReactNode;
  className?: string;
  transparentLabel?: boolean;
  transparentValue?: boolean;
  boldValue?: boolean;
  mobileOpacity?: number;
  desktopOpacity?: number;
  style?: CSSProperties;
  'data-e2e'?: string;
};

export default function Text({
  label,
  value,
  children,
  className,
  transparentLabel = true,
  transparentValue = false,
  boldValue = true,
  mobileOpacity = 0.5,
  desktopOpacity = 0.8,
  style,
  'data-e2e': automationPrefix,
  ...props
}: TextProps) {
  const opacity = DeviceInfo.isHandheld ? mobileOpacity : desktopOpacity;

  return (
    <span
      data-e2e={automationPrefix}
      className={cx(textContainer, className)} style={style} {...props}
    >
      <span
        data-e2e={`${automationPrefix}-label`}
        style={{ ...(transparentLabel && { opacity }) }}
      >
        {label}
        {value ? '\u00A0' : null}
      </span>
      <span
        data-e2e={`${automationPrefix}-value`}
        style={{
          ...(boldValue && { fontWeight: 'bold' }),
          ...(transparentValue && { opacity }),
        }}
      >
        {value}
      </span>
      {children}
    </span>
  );
}
